import {MeasurementUnits} from './MeasurementUnits';

export class StockProducts {
    productCode: string;
    description: string;
    affectationIGV: string;
    measurementUnit: MeasurementUnits;
    unitPrice: number;
    mUnits: string;

    constructor() {
        this.productCode = '';
        this.description = '';
        this.affectationIGV = 'GRAVADO';
        const unit = new MeasurementUnits();
        unit.id = 1;
        unit.code = 'NIU';
        unit.description = 'number of international units';
        unit.label = 'Unidades';
        this.unitPrice = 0;
        this.measurementUnit = unit;
        this.mUnits = unit.label;
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/recursos/modelo/stockProducts.ts